export function scheduledRoutePrefillFromHash(hash) {
  const params = new URLSearchParams((hash || "").replace(/^#/, ""));

  return {
    monitorId: validPrefillId(params.get("monitor_id")),
    lotId: validPrefillId(params.get("lot_id")),
  };
}

export function validPrefillId(value) {
  return /^\d+$/.test(value || "") ? value : null;
}
